module.exports = __webpack_public_path__ + "img/candidate.b04f81ec.png";